module.exports = __webpack_public_path__ + "static/media/Philo_History.9c7d6cfe.md";